export enum TaxFormViewer {
  Payer = "Payer",
  Payee = "Payee"
}
